import { takeLatest } from 'redux-saga/effects';
import {
  getInvoiceListSuccess, getInvoiceListFail,
  getInvoiceDetailsSuccess, getInvoiceDetailsFail,
  doXeroConnectionSuccess, doXeroConnectionFail
} from './invoiceState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/finance/invoices');
const redirectData = {route:'console/invoices', mode: 'list', recordId:0 };
const modelName = 'Invoice';
const modelId = 'pay_id';
const xeroService = createCrudService('api/v1/xero');

function* getInvoiceList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getInvoiceListSuccess, 
		getInvoiceListFail,
		null, null, LOADING_MSG);
}

function* getInvoiceDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getInvoiceDetailsSuccess, 
		getInvoiceDetailsFail,
		null, null, LOADING_MSG);  	
}

function* doInvoiceCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getInvoiceDetailsSuccess, 
		getInvoiceDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);	
}

function* doInvoiceUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getInvoiceDetailsSuccess, 
		getInvoiceDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: 'reload'}, 
		UPDATING_MSG);	
}

function* doInvoiceDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getInvoiceDetailsSuccess, 
		getInvoiceDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* doInvoiceProgressUpdate(data){
	
	const { invoiceId, process } = data.payload;
	
	yield doCrudCall(
		() => crudService.doPostRequest(`${invoiceId}/progress/update/${process}`, null), 
		getInvoiceDetailsSuccess, 
		getInvoiceDetailsFail,
		updateRecordSuccess(modelName),
		process === 'payreg validated' ? null : {...redirectData, mode: 'reload'},
		UPDATING_MSG);	
}

function* doGenerateMonthlyInvoice(data){
	yield doCrudCall(
		() => crudService.doPostRequest(`generate/monthly`, data.payload), 
		getInvoiceDetailsSuccess, 
		getInvoiceDetailsFail,
		null,
		redirectData,
		LOADING_MSG);	
}

function* doInvoicesPushToXero(data){
	yield doCrudCall(
		() => crudService.doPostRequest(`submit-xero`, data.payload), 
		getInvoiceDetailsSuccess, 
		getInvoiceDetailsFail,
		null,
		redirectData,
		SAVING_MSG);
}

function* invoiceSaga() {
  	yield takeLatest('invoice/getInvoiceList', getInvoiceList);
  	yield takeLatest('invoice/getInvoiceDetails', getInvoiceDetails);
  	yield takeLatest('invoice/doInvoiceCreate', doInvoiceCreate);
  	yield takeLatest('invoice/doInvoiceUpdate', doInvoiceUpdate);
  	yield takeLatest('invoice/doInvoiceDelete', doInvoiceDelete);  
  	yield takeLatest('invoice/doInvoiceProgressUpdate', doInvoiceProgressUpdate);
	yield takeLatest('invoice/doGenerateMonthlyInvoice', doGenerateMonthlyInvoice);
	yield takeLatest('invoice/doInvoicesPushToXero', doInvoicesPushToXero);
}

export default invoiceSaga;
